export const FETCH_FUN_FACT = 'FETCH_FUN_FACT';

export const setFact = (payload: any) => {
    return {
        type: FETCH_FUN_FACT,
        payload,
    };
};
